// Fewest letters or digits a form search needs before the query is sent.
export const MIN_SEARCH_CHARS = 2;

const isSearchableQuery = (value: string) => (value.match(/[\p{L}\p{N}]/gu) ?? []).length >= MIN_SEARCH_CHARS;

export default isSearchableQuery;
